
import Vue from 'vue'
import Component from 'vue-class-component'
import ErrorHandler from '@/services/ErrorHandlerService'
import { INotificationService } from '@/services/NotificationService'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'
import {User} from "@/models/user";
import UserService from "@/services/UserService";

const Props = Vue.extend({
  props: {
    onClose: Function,
  },
})

@Component({
  components: {
    ProgressLinear,
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class UsersChangeStatus extends Props {
  private dialog: boolean = false
  private isPending: boolean = false

  private userAccount: User = {} as User

  private errorHandler = new ErrorHandler()
  private $notificationService!: INotificationService

  public show(account: User) {
    this.userAccount = account
    this.dialog = true
  }

  private hide() {
    this.onClose()
    this.dialog = false
  }

  private async changeUserAccountStatus() {
    this.isPending = true
    try {
      if (this.userAccount.ad_est_actif) {
        await UserService.disable(
          this.userAccount.ad_personne_id,
          this.userAccount.identifiant,
        )
        this.$notificationService.success(
          this.$t('USER.DisableSuccess').toString(),
        )
        this.userAccount.ad_est_actif = false
        this.hide()
      } else if (!this.userAccount.ad_est_actif) {
        await UserService.enable(
          this.userAccount.ad_personne_id,
          this.userAccount.identifiant,
        )
        this.$notificationService.success(
          this.$t('USER.EnableSuccess').toString(),
        )
        this.userAccount.ad_est_actif = true
        this.hide()
      }
    } catch (error: any) {
      this.errorHandler.handle(this, error.response.data.code, true)
    } finally {
      this.isPending = false
    }
    this.isPending = false
  }
}
